import { Component, Inject, OnDestroy } from '@angular/core';

import { Store } from '@src/store';
import { DialogManagerService } from '@src/services';
import { TranslatePipe } from '@app/shared/pipes/translate.pipe';
import { commandsActions } from '@src/store/reducers/commandsReducer';

@Component({
    selector: 'automation',
    template: require('./automation.component.html'),
    styles: [require('./automation.component.scss')]
})
export class AutomationComponent implements OnDestroy {
    public data: any;
    public commandsData: any;
    public selectedIndex: number;

    private projectId: any;
    private envID: any;
    private selectedCommand: any;
    private unsubscribe: any;

    constructor(
        private store: Store,
        @Inject('$stateParams') $stateParams: any,
        private dialogManagerService: DialogManagerService,
        private translatePipe: TranslatePipe) {
        this.projectId = $stateParams.id;
        this.envID = $stateParams.envID;
        this.unsubscribe = this.store.subscribe(() => {
            this.commandsData = this.store.getState().automation;
            this.selectedCommand = this.store.getState().automation.selectedCommandName;
            if (this.selectedCommand) {
                this.data = {
                    name: this.selectedCommand,
                    selectedCommandFields: this.commandsData.selectedCommandFields
                };
            }
            if (this.commandsData.commandLineScript) {
                this.data.commandLineScript = this.commandsData.commandLineScript;
            }
        });
        const payload = { projectId: this.projectId, envID: this.envID };
        this.store.dispatch({ payload, type: commandsActions.GET_COMMANDS });
    }

    public ngOnDestroy() {
        this.unsubscribe();
    }

    public onClickCommand(data: any) {
        const payload = {
            projectId: this.projectId,
            envID: this.envID,
            commandName: data,
            commands: this.commandsData.commands
        };
        this.store.dispatch({ payload, type: commandsActions.GET_COMMAND_PROPERTIES });
        this.selectedCommand = null;
    }

    public async onGenerateScript(data: any) {
        this.data = data;
        const translations = await this.translatePipe.transform(['ERROR', 'ERROR_FIELD_RQUEIRED']);
        const json = {};
        for (const field of this.data.selectedCommandFields) {
            if (field.isMust && !field.value) {
                const title = translations['ERROR'];
                const text = `${field.name}  ${translations['ERROR_FIELD_RQUEIRED']}`;
                this.dialogManagerService.showErrorDialog({ title, text });
                return;
            }
            if (field.isSelected) {
                json[field.name] = field.value;
            }
        }
        const payload = { projectId: this.projectId, envID: this.envID, commandName: this.data.name, params: json };
        this.store.dispatch({ payload, type: commandsActions.GET_GENERATE_SCRIPT });
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/environmentDetails/automation/automation.component.ts